// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("wave.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800;900&display=swap");

/** {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}*/

body {
  /*display: flex;*/
  justify-content: flex-end;
  align-items: flex-end;
  min-height: 100vh;
}

.footer {
  position: relative;
  /* background: linear-gradient(to right, #0014ff, #0080ff); /* Градиент от левого края к правому 3586ff*/
  background: #3586ff;
  padding: 20px 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footer-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  margin-bottom: 20px;
  align-items: flex-start; /* Align items at the start */
}

.footer-column {
  display: flex;
  flex-direction: column;
}

.footer-logo {
  margin-right: 50px; /* Add space between the logo and the next column */
}

.footer-logo img {
  max-width: 150px;
  margin-bottom: 0; /* Remove bottom margin to align logo with the content next to it */
}

.menu2 {
  list-style: none;
  padding: 0;
}

.menu__item {
  margin-bottom: 10px;
}

.menu__link  {
  font-size: 1.1rem;
  color: #ffffff;
  text-decoration: none;
  opacity: 0.75;
  transition: opacity 0.5s;
  font-weight: 300;
}

.menu__link:hover {
  opacity: 1;
}


.footer p {
  color: #ffffff;
  margin: 15px 0 10px 0;
  font-size: 1rem;
  font-weight: 300;
}

.wave {
  position: absolute;
  top: -100px;
  left: 0;
  width: 100%;
  height: 100px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 1000px 100px;
}



.partners-logos  ul {
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  padding: 0;
  display: flex;
  gap: 15px;
}

.partners-logos img {
  max-width: 50px;
  border-radius: 20px;
  flex: auto;
}


.wave#wave1 {
  z-index: 999;
  opacity: 1;
  bottom: 0;
  animation: animateWaves 15s linear infinite; /* Было 4s */
}

.wave#wave2 {
  z-index: 998;
  opacity: 0.5;
  bottom: 10px;
  animation: animate 15s linear infinite !important; /* Было 4s */
}

.wave#wave3 {
  z-index: 999;
  opacity: 0.2;
  bottom: 15px;
  animation: animateWaves 10s linear infinite; /* Было 3s */
}

.wave#wave4 {
  z-index: 998;
  opacity: 0.7;
  bottom: 20px;
  animation: animate 10s linear infinite; /* Было 3s */
}

@keyframes animateWaves {
  0% {
    background-position-x: 1000px;
  }
  100% {
    background-position-x: 0px;
  }
}

@keyframes animate {
  0% {
    background-position-x: -1000px;
  }
  100% {
    background-position-x: 0px;
  }
}

/* Мобильная адаптация */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    align-items: center;
  }

  .footer-column {
    margin-bottom: 20px;
    align-items: center; /* Выравнивание по центру */
    text-align: center;  /* Центрирование текста */
  }

  .footer-logo {
    margin-right: 0; /* Убрать отступ справа у логотипа */
    margin-bottom: 20px; /* Добавить отступ снизу */
  }

  .footer-logo img {
    max-width: 120px; /* Уменьшить размер логотипа */
  }

  .menu__link {
    font-size: 1rem; /* Уменьшить размер шрифта */
  }

  .menu__item p {
    font-size: 0.9rem; /* Уменьшить размер текста для информации */
  }

  .footer p {
    font-size: 0.9rem; /* Уменьшить размер текста в футере */
  }

  .partners-logos ul {
    justify-content: center;
  }

  .partners-logos img {
    max-width: 40px; /* Уменьшить размер логотипов партнеров */
  }


}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wGAAwG;EACxG,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB,EAAE,6BAA6B;AACxD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB,EAAE,mDAAmD;AACzE;;AAEA;EACE,gBAAgB;EAChB,gBAAgB,EAAE,mEAAmE;AACvF;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;EACX,aAAa;EACb,mDAA2B;EAC3B,6BAA6B;AAC/B;;;;AAIA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,UAAU;AACZ;;;AAGA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,2CAA2C,EAAE,YAAY;AAC3D;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,iDAAiD,EAAE,YAAY;AACjE;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,2CAA2C,EAAE,YAAY;AAC3D;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,sCAAsC,EAAE,YAAY;AACtD;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB,EAAE,2BAA2B;IAChD,kBAAkB,GAAG,yBAAyB;EAChD;;EAEA;IACE,eAAe,EAAE,oCAAoC;IACrD,mBAAmB,EAAE,0BAA0B;EACjD;;EAEA;IACE,gBAAgB,EAAE,8BAA8B;EAClD;;EAEA;IACE,eAAe,EAAE,4BAA4B;EAC/C;;EAEA;IACE,iBAAiB,EAAE,2CAA2C;EAChE;;EAEA;IACE,iBAAiB,EAAE,qCAAqC;EAC1D;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe,EAAE,yCAAyC;EAC5D;;;AAGF","sourcesContent":["/*@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800;900&display=swap\");\r\n\r\n/** {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  font-family: \"Poppins\", sans-serif;\r\n}*/\r\n\r\nbody {\r\n  /*display: flex;*/\r\n  justify-content: flex-end;\r\n  align-items: flex-end;\r\n  min-height: 100vh;\r\n}\r\n\r\n.footer {\r\n  position: relative;\r\n  /* background: linear-gradient(to right, #0014ff, #0080ff); /* Градиент от левого края к правому 3586ff*/\r\n  background: #3586ff;\r\n  padding: 20px 50px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n.footer-content {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  margin-bottom: 20px;\r\n  align-items: flex-start; /* Align items at the start */\r\n}\r\n\r\n.footer-column {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.footer-logo {\r\n  margin-right: 50px; /* Add space between the logo and the next column */\r\n}\r\n\r\n.footer-logo img {\r\n  max-width: 150px;\r\n  margin-bottom: 0; /* Remove bottom margin to align logo with the content next to it */\r\n}\r\n\r\n.menu2 {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.menu__item {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.menu__link  {\r\n  font-size: 1.1rem;\r\n  color: #ffffff;\r\n  text-decoration: none;\r\n  opacity: 0.75;\r\n  transition: opacity 0.5s;\r\n  font-weight: 300;\r\n}\r\n\r\n.menu__link:hover {\r\n  opacity: 1;\r\n}\r\n\r\n\r\n.footer p {\r\n  color: #ffffff;\r\n  margin: 15px 0 10px 0;\r\n  font-size: 1rem;\r\n  font-weight: 300;\r\n}\r\n\r\n.wave {\r\n  position: absolute;\r\n  top: -100px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100px;\r\n  background: url(\"wave.png\");\r\n  background-size: 1000px 100px;\r\n}\r\n\r\n\r\n\r\n.partners-logos  ul {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  list-style-type: none;\r\n  padding: 0;\r\n  display: flex;\r\n  gap: 15px;\r\n}\r\n\r\n.partners-logos img {\r\n  max-width: 50px;\r\n  border-radius: 20px;\r\n  flex: auto;\r\n}\r\n\r\n\r\n.wave#wave1 {\r\n  z-index: 999;\r\n  opacity: 1;\r\n  bottom: 0;\r\n  animation: animateWaves 15s linear infinite; /* Было 4s */\r\n}\r\n\r\n.wave#wave2 {\r\n  z-index: 998;\r\n  opacity: 0.5;\r\n  bottom: 10px;\r\n  animation: animate 15s linear infinite !important; /* Было 4s */\r\n}\r\n\r\n.wave#wave3 {\r\n  z-index: 999;\r\n  opacity: 0.2;\r\n  bottom: 15px;\r\n  animation: animateWaves 10s linear infinite; /* Было 3s */\r\n}\r\n\r\n.wave#wave4 {\r\n  z-index: 998;\r\n  opacity: 0.7;\r\n  bottom: 20px;\r\n  animation: animate 10s linear infinite; /* Было 3s */\r\n}\r\n\r\n@keyframes animateWaves {\r\n  0% {\r\n    background-position-x: 1000px;\r\n  }\r\n  100% {\r\n    background-position-x: 0px;\r\n  }\r\n}\r\n\r\n@keyframes animate {\r\n  0% {\r\n    background-position-x: -1000px;\r\n  }\r\n  100% {\r\n    background-position-x: 0px;\r\n  }\r\n}\r\n\r\n/* Мобильная адаптация */\r\n@media (max-width: 768px) {\r\n  .footer-content {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n  .footer-column {\r\n    margin-bottom: 20px;\r\n    align-items: center; /* Выравнивание по центру */\r\n    text-align: center;  /* Центрирование текста */\r\n  }\r\n\r\n  .footer-logo {\r\n    margin-right: 0; /* Убрать отступ справа у логотипа */\r\n    margin-bottom: 20px; /* Добавить отступ снизу */\r\n  }\r\n\r\n  .footer-logo img {\r\n    max-width: 120px; /* Уменьшить размер логотипа */\r\n  }\r\n\r\n  .menu__link {\r\n    font-size: 1rem; /* Уменьшить размер шрифта */\r\n  }\r\n\r\n  .menu__item p {\r\n    font-size: 0.9rem; /* Уменьшить размер текста для информации */\r\n  }\r\n\r\n  .footer p {\r\n    font-size: 0.9rem; /* Уменьшить размер текста в футере */\r\n  }\r\n\r\n  .partners-logos ul {\r\n    justify-content: center;\r\n  }\r\n\r\n  .partners-logos img {\r\n    max-width: 40px; /* Уменьшить размер логотипов партнеров */\r\n  }\r\n\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
